import { clinicAuthClient } from "@auth/clinicAuthClient";
import { useSessionStore } from "@auth/sessionStore";
import { AuthContext, type AuthContextValue } from "@context/AuthContext";
import { useCallback, useMemo, type ReactNode } from "react";

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const session = useSessionStore((s) => s.clinic);

  const logout = useCallback(() => {
    const { clinic, user } = useSessionStore.getState();
    useSessionStore.getState().clearAll();
    if (user) void clinicAuthClient.logout(user.refreshToken);
    if (clinic) void clinicAuthClient.logout(clinic.refreshToken);
  }, []);

  const login = useCallback(async (subdomain: string, password: string) => {
    const next = await clinicAuthClient.login(subdomain, password);
    useSessionStore.getState().setClinic(next);
  }, []);

  const value = useMemo<AuthContextValue>(
    () => ({
      session,
      isAuthed: session !== null,
      login,
      logout,
    }),
    [session, login, logout],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
